export const Roles = {
  superAdmin: 'superadmin',
  manager: 'manager',
  lead: 'lead',
  master: 'master',
};
